"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComEpics = void 0;
var _reduxObservable = require("redux-observable");
var _operators = require("rxjs/operators");
var _rxjs = require("rxjs");
var _types = require("./types");
var _types2 = require("../game/types");
var _GameStatus = require("../enums/GameStatus");
var _types3 = require("../ui/types");
var _FeatureAwardType = require("../enums/FeatureAwardType");
var _types4 = require("../config/types");
var _types5 = require("../loader/types");
var _types6 = require("../blitz/types");
var _RoundState = require("../enums/RoundState");
var _types7 = require("../autoPlay/types");
var _DialogState = require("../../../ui/enums/DialogState");
var _errorReporter = require("../../../utils/errorReporter");
var _CommandType = require("../../dovahzul/CommandType");
var _ErrorMessages = require("../../dovahzul/ErrorMessages");
var _BalanceRequest = require("../../dovahzul/requests/BalanceRequest");
var _StatEventRequest = require("../../dovahzul/requests/StatEventRequest");
var _StatEventType = require("../../dovahzul/StatEventType");
var _logger = _interopRequireDefault(require("../../../utils/logger"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ComEpics = exports.ComEpics = /*#__PURE__*/function () {
  function ComEpics() {
    _classCallCheck(this, ComEpics);
    _defineProperty(this, "commandSessionExpiredHandler", function (action$) {
      return action$.pipe((0, _reduxObservable.ofType)(_types.COMMAND_RECEIVED), (0, _operators.filter)(function (a) {
        return _CommandType.CommandType.SessionExpired === a.payload.type;
      }), (0, _operators.mergeMap)(function () {
        return (0, _rxjs.concat)((0, _rxjs.of)({
          type: _types.DISCONNECT
        }), (0, _rxjs.of)({
          type: _types2.GAME_STATUS_SET,
          payload: _GameStatus.GameStatus.Timeout
        }), (0, _rxjs.of)({
          type: _types.SESSION_EXPIRED
        }));
      }));
    });
    /**
     * handle when server says game is ready server side. this protects against slow reconnects etc. 
     * @param action$ 
     * @returns 
     */
    _defineProperty(this, "commandGameReadyHandler", function (action$) {
      return action$.pipe((0, _reduxObservable.ofType)(_types.COMMAND_RECEIVED), (0, _operators.filter)(function (a) {
        return _CommandType.CommandType.GameReadyResponse === a.payload.type;
      }), (0, _operators.mapTo)({
        type: _types2.SERVER_GAME_READY
      }));
    });
    /**
     * We store the last collect action. this is so that it can be resent when turning blitz on/off to restore the collect state.
     *
     * Note this is really only relevant for features that span multiple rounds.
     */
    _defineProperty(this, "commandFeatureCollectHandler", function (action$) {
      return action$.pipe((0, _reduxObservable.ofType)(_types.COMMAND_RECEIVED), (0, _operators.filter)(function (a) {
        return _CommandType.CommandType.FeatureWinResponse === a.payload.type && (a.payload.awardType === _FeatureAwardType.FeatureAwardType.Collect || a.payload.awardType === _FeatureAwardType.FeatureAwardType.CollectReward);
      }), (0, _operators.mergeMap)(function (a) {
        if (a.payload.awardType === _FeatureAwardType.FeatureAwardType.Collect) {
          return (0, _rxjs.of)({
            type: _types.COMMAND_FEATURE_STORE,
            payload: a
          });
        } else {
          return (0, _rxjs.of)({
            type: _types.COMMAND_FEATURE_STORE_CLEAR
          });
        }
      }));
    });
    /***
     * Ensure we hide splash on spin start or reciveing spinresponse as a reconnect
     */
    _defineProperty(this, "removeSplashScreenOnReconnectOrSpin", function (action$) {
      return action$.pipe((0, _reduxObservable.ofType)(_types.COMMAND_RECEIVED, _types.COMMAND_SEND), (0, _operators.filter)(function (a) {
        return _CommandType.CommandType.SpinResponse === a.payload.type || _CommandType.CommandType.SpinRequest === a.payload.type;
      }), (0, _operators.take)(1), (0, _operators.mapTo)({
        type: _types4.HIDE_SPLASH_SCREEN
      }));
    });
    _defineProperty(this, "connectionFailedHandler", function (action$) {
      return action$.pipe((0, _reduxObservable.ofType)(_types.CONNECTION_FAILED, _types5.LOAD_FAILED), (0, _operators.mapTo)({
        type: _types2.GAME_STATUS_SET,
        payload: _GameStatus.GameStatus.FailedToConnect
      }));
    });
    _defineProperty(this, "disconnectedHandler", function (action$) {
      return action$.pipe((0, _reduxObservable.ofType)(_types.DISCONNECTED), (0, _operators.mapTo)({
        type: _types2.GAME_STATUS_SET,
        payload: _GameStatus.GameStatus.Disconnected
      }));
    });
    _defineProperty(this, "reconnectedHandler", function (action$) {
      return action$.pipe((0, _reduxObservable.ofType)(_types.RECONNECTED), (0, _operators.mapTo)({
        type: _types2.GAME_STATUS_SET,
        payload: _GameStatus.GameStatus.Idle
      }));
    });
    _defineProperty(this, "commandMaintenanceHandler", function (action$) {
      return action$.pipe((0, _reduxObservable.ofType)(_types.COMMAND_RECEIVED), (0, _operators.filter)(function (a) {
        return _CommandType.CommandType.Maintenance === a.payload.type;
      }), (0, _operators.mergeMap)(function (a) {
        return (0, _rxjs.of)({
          type: _types2.GAME_STATUS_SET,
          payload: _GameStatus.GameStatus.Maintenance
        });
      }));
    });
    _defineProperty(this, "commandIdentierHandler", function (action$) {
      return action$.pipe((0, _reduxObservable.ofType)(_types.COMMAND_RECEIVED), (0, _operators.filter)(function (a) {
        return _CommandType.CommandType.IdentifierResponse === a.payload.type;
      }), (0, _operators.mergeMap)(function (a) {
        return (0, _rxjs.of)({
          type: _types4.SERVER_CONFIG,
          payload: {
            connectionId: a.payload.connectionId
          }
        });
      }));
    });
    _defineProperty(this, "commandRoundDebugHandler", function (action$) {
      return action$.pipe((0, _reduxObservable.ofType)(_types.COMMAND_RECEIVED), (0, _operators.filter)(function (a) {
        return _CommandType.CommandType.RoundDebugResponse === a.payload.type;
      }), (0, _operators.mergeMap)(function (a) {
        _logger["default"].dir("***RoundDebug****", a.payload);
        return _rxjs.EMPTY;
      }));
    });
    _defineProperty(this, "commandErrorHandler", function (action$, store) {
      return action$.pipe((0, _reduxObservable.ofType)(_types.COMMAND_RECEIVED), (0, _operators.filter)(function (a) {
        return _CommandType.CommandType.Error === a.payload.type;
      }), (0, _operators.mergeMap)(function (a) {
        var errorType = a.payload.message;
        console.error("Server Error: " + errorType);
        // This sensures that the client kills its connection not hogging a port on error.
        var actions = [{
          type: _types.DISCONNECT
        }];
        //Unrecoverable Errors
        switch (errorType) {
          case _ErrorMessages.ErrorMessages.InvalidToken:
            {
              return (0, _rxjs.concat)(actions, (0, _rxjs.of)({
                type: _types2.GAME_STATUS_SET,
                payload: _GameStatus.GameStatus.InvalidToken
              }));
            }
          case _ErrorMessages.ErrorMessages.GameInEarlyAccess:
            {
              return (0, _rxjs.concat)(actions, (0, _rxjs.of)({
                type: _types2.GAME_STATUS_SET,
                payload: _GameStatus.GameStatus.GameInEarlyAccess
              }));
            }
          case _ErrorMessages.ErrorMessages.PlayerLocked:
            {
              return (0, _rxjs.concat)(actions, (0, _rxjs.of)({
                type: _types2.GAME_STATUS_SET,
                payload: _GameStatus.GameStatus.PlayerLocked
              }));
            }
          case _ErrorMessages.ErrorMessages.InvalidPlayerId:
            {
              return (0, _rxjs.concat)(actions, (0, _rxjs.of)({
                type: _types2.GAME_STATUS_SET,
                payload: _GameStatus.GameStatus.InvalidPlayerId
              }));
            }
          case _ErrorMessages.ErrorMessages.ReplayRoundIdNotFound:
            {
              return (0, _rxjs.concat)(actions, (0, _rxjs.of)({
                type: _types2.GAME_STATUS_SET,
                payload: _GameStatus.GameStatus.ReplayRoundIdNotFound
              }));
            }
          case _ErrorMessages.ErrorMessages.BadResponse:
          case _ErrorMessages.ErrorMessages.Timeout:
          case _ErrorMessages.ErrorMessages.APIDown:
            {
              return (0, _rxjs.concat)(actions, (0, _rxjs.of)({
                type: _types2.GAME_STATUS_SET,
                payload: _GameStatus.GameStatus.APIDown
              }));
            }
          case _ErrorMessages.ErrorMessages.CountryBlocked:
            {
              (0, _errorReporter.reportError)("Country blocked on start " + store.value.config.gameId + " integration " + store.value.config.iId);
              return (0, _rxjs.concat)(actions, (0, _rxjs.of)({
                type: _types2.GAME_STATUS_SET,
                payload: _GameStatus.GameStatus.CountryBlocked
              }));
            }
          // we do the same thing as wehn the specific "Expired" command is sent by the server.
          //this occurs when the session has been taken over or perhaps for some reason the client did not get the expired command and tried to make a bet.
          case _ErrorMessages.ErrorMessages.InvalidExpiredSession:
            {
              return (0, _rxjs.concat)((0, _rxjs.of)({
                type: _types2.GAME_STATUS_SET,
                payload: _GameStatus.GameStatus.Timeout
              }), (0, _rxjs.of)({
                type: _types.SESSION_EXPIRED
              }));
            }
          //recoverable errors
          case _ErrorMessages.ErrorMessages.InsufficientBalance:
            {
              return (0, _rxjs.concat)((0, _rxjs.of)({
                type: _types7.AUTO_PLAY_STOP
              }), (0, _rxjs.of)({
                type: _types6.BLITZ_PLAY_STOP
              }), (0, _rxjs.of)({
                type: _types2.ROUND_VOID
              }), (0, _rxjs.of)({
                type: _types3.DIALOG_STATE,
                payload: _DialogState.DialogState.INSUFFICIENT_BALANCE
              }));
            }
          case _ErrorMessages.ErrorMessages.LimitsReached:
            {
              return (0, _rxjs.concat)((0, _rxjs.of)({
                type: _types2.ROUND_VOID
              }), (0, _rxjs.of)({
                type: _types3.DIALOG_STATE,
                payload: _DialogState.DialogState.LIMITS_REACHED
              }));
            }
          //  case ErrorMessages.InvalidGameMathModelId:
          //  case ErrorMessages.GameUnavailable:
          //  case ErrorMessages.InvalidBet:
          //  case ErrorMessages.InvalidPromotionBet:
          //  case ErrorMessages.ContactSupport:
          default:
            {
              (0, _errorReporter.reportError)("Server Error: " + errorType + " " + store.value.config.gameId + " integration " + store.value.config.iId + " " + errorType + " " + store.value.config.rmmid);
              return (0, _rxjs.concat)(actions, (0, _rxjs.of)({
                type: _types2.GAME_STATUS_SET,
                payload: _GameStatus.GameStatus.ContactSupport
              }));
            }
        }
      }));
    });
    _defineProperty(this, "commandHandlerResume", function (action$) {
      return action$.pipe((0, _reduxObservable.ofType)(_types.COMMAND_RESUME), (0, _operators.mapTo)({
        type: _types.COMMAND_QUEUE_NEXT
      }));
    });
    _defineProperty(this, "commandHandlerDequeue", function (action$, store) {
      return action$.pipe(
      //   delay(500), for debug only
      (0, _reduxObservable.ofType)(_types.COMMAND_QUEUE_NEXT), (0, _operators.filter)(function () {
        return !!store.value.com.command;
      }), (0, _operators.mergeMap)(function (a) {
        return (0, _rxjs.of)({
          type: _types.COMMAND_PLAY,
          payload: store.value.com.command
        });
      }));
    });
    _defineProperty(this, "commandHandler", function (action$, store) {
      return action$.pipe((0, _reduxObservable.ofType)(_types.COMMAND_RECEIVED),
      //    delay(2000),  for debug only
      (0, _operators.filter)(function (a) {
        return [_CommandType.CommandType.SpinResponse, _CommandType.CommandType.RoundStartResponse, _CommandType.CommandType.RoundEndResponse, _CommandType.CommandType.BalanceResponse, _CommandType.CommandType.PayLineWinResponse, _CommandType.CommandType.FeatureWinResponse, _CommandType.CommandType.FeatureEndResponse, _CommandType.CommandType.PromotionAvailableResponse, _CommandType.CommandType.PromotionEndResponse, _CommandType.CommandType.SetReelsResponse, _CommandType.CommandType.BlitzStartResponse, _CommandType.CommandType.BlitzStopResponse, _CommandType.CommandType.UnfinishedGameResponse, _CommandType.CommandType.PayLineEndResponse, _CommandType.CommandType.SpinEndResponse, _CommandType.CommandType.PayWayWinResponse, _CommandType.CommandType.PayWayEndResponse, _CommandType.CommandType.ResumeGameResponse, _CommandType.CommandType.ContinueWaitResponse, _CommandType.CommandType.PlayerActionResponse, _CommandType.CommandType.ReplayResponse].indexOf(a.payload.type) > -1 || a.payload.type > 4999;
      }), (0, _operators.mergeMap)(function (a) {
        if (!store.value.com.command && !store.value.com.commandPause) return (0, _rxjs.of)({
          type: _types.COMMAND_PLAY,
          payload: a.payload
        });else return (0, _rxjs.of)({
          type: _types.COMMAND_QUEUE,
          payload: a.payload
        });
      }));
    });
    /**
     * request balance, throttle to prevent to many calls and filter if called during a round.
     */
    _defineProperty(this, "requestBalance", function (action$, store) {
      return action$.pipe((0, _reduxObservable.ofType)(_types.REQUEST_BALANCE), (0, _operators.filter)(function (a) {
        return store.value.game.roundState == _RoundState.RoundState.Ended || store.value.blitz.playing == true;
      }), (0, _operators.throttle)(function (val) {
        return (0, _rxjs.interval)(1500);
      }), (0, _operators.mapTo)({
        type: _types.COMMAND_SEND,
        payload: new _BalanceRequest.BalanceRequest()
      }));
    });
    /**
     * Send game state event
     */
    _defineProperty(this, "stats", function (action$, store) {
      return action$.pipe((0, _reduxObservable.ofType)(_types2.GAME_READY), (0, _operators.take)(1), (0, _operators.filter)(function (a) {
        return !store.value.replay.replayLaunch;
      }),
      // dont send stat on replay launch
      (0, _operators.mergeMap)(function (a) {
        return (0, _rxjs.of)({
          type: _types.COMMAND_SEND,
          payload: new _StatEventRequest.StatEventRequest(_StatEventType.StatEventType.GameStart, {
            time: store.value.loader.finishedTime.getTime() - store.value.loader.initTime.getTime()
          })
        });
      }));
    });
  }
  return _createClass(ComEpics, [{
    key: "getEpic",
    value: function getEpic() {
      return (0, _reduxObservable.combineEpics)(this.commandErrorHandler, this.commandSessionExpiredHandler, this.connectionFailedHandler, this.disconnectedHandler, this.reconnectedHandler, this.commandFeatureCollectHandler, this.commandHandlerResume, this.commandHandler, this.commandHandlerDequeue, this.removeSplashScreenOnReconnectOrSpin, this.requestBalance, this.commandMaintenanceHandler, this.stats, this.commandRoundDebugHandler, this.commandIdentierHandler, this.commandGameReadyHandler);
    }
  }]);
}();
//# sourceMappingURL=epics.js.map